var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 213",
    style: {
      enableBackground: "new 0 0 212.6 213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#9A1D4C;}\n\t.st2{fill:#A72B49;}\n\t.st3{fill:#AB2C3D;}\n\t.st4{fill:#A4263E;}\n\t.st5{fill:url(#SVGID_00000067221752908193866290000001596492441246249876_);}\n\t.st6{fill:#FFD9BB;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.5409,
    y1: 0.781,
    x2: 106.5409,
    y2: 213.8557,
    gradientTransform: "matrix(1 0 0 -1 0 213.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C7544B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B63651"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206,129.8c0-0.1,0-0.1,0-0.1c-1.4-4.5-2.8-8.9-4.1-13.4c-1.3-4.8-2.5-9.5-3.2-14.3c-0.7-4.5-1.2-8.5-1.7-12 l0,0c-1.8-13.5-2.7-20.8-5.9-32.4C187,43,155.3,33.5,149.6,29.8C134.8,20.3,127,2.3,103.8,0.2S68.7,16.3,44.5,35.5l0,0l-3.9,3.1 l0,0C19.7,55.2,14.7,59.3,9.2,72.7c-5.8,14.1,0,34.3-4.6,55.4c-1.8,8.4-3.3,17.9-3.8,27c-0.3,5.8-0.2,11.4,0.5,16.7 c1,7,3,13.2,6.6,17.8c4,5.1,8.9,8.6,13.5,10.9c1.1,1.6,2.4,3.2,3.8,4.6c0,0,1.9,1,5.2,2.3c0.1,0,0.1,0.1,0.1,0.1h0.1 c1.3,0.5,2.8,1,4.4,1.6l0,0c3.7,1.2,8.4,2.4,13.8,3.2c0,0,0,0,0.1,0h0.2c1.9,0.3,3.9,0.5,6,0.6l0,0c0,0,0,0,0.1,0l0,0 c3,0.2,6.1,0.3,9.4,0.1c0,0-24.2-28.6-26.9-70.6c0.3,1.9,5,33.1,12.5,44.3c-0.1-0.6-3-13.8-4.7-31.9v-0.1c-1-10.4-1.5-22.4-1-34.5 c1.6-33.8,19.2-72,32.6-81.7c13.3-9.7,47.5-10.7,58.8-2.4l-0.6-3.6l3.4,2.8l0.4,0.3l1-1l3.9,2.2l-1.8,1.7c0,0,3.5,3.2,8.1,8.6l0,0 c6.9,8.1,16.2,21,20,35.4c6.5,24.1-0.7,97.3-7.4,120.6c0,0,9.5-12.3,13.7-25.3c-2.2,8.2-6.6,21.1-14.7,32c0,0,9.2,2.4,19.8-3.6 c7.9-4.5,16.7-15.6,22.2-25.4c-0.5,1-6.7,14.4-15.4,22.2c0,0,0,0-0.1,0l0,0c-1.2,1.1-2.4,2-3.6,2.8c0.8-0.4,25-11.9,27.3-35.9 C213.6,156,209.9,142.7,206,129.8z M11.7,175.7c-1.6-8.8-1.1-20.1,2.9-34.5c-0.3,1.2-5.1,25.8,0.9,46.2 C13.8,184.1,12.5,180.3,11.7,175.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,35.5l-3.4-2.8l0.6,3.6C124.5,28,90.4,29,77.1,38.7c-13.4,9.7-31,47.8-32.6,81.7 c-0.6,12.1,0,24.1,1,34.5c-5.7-41.1,2.2-73.8,2.2-73.8S37.6,112.5,35.1,152c-2.5,38.9,19.4,60.4,20,61l0,0H55l0,0l-6-0.6h-0.2l0,0 l0,0c-0.4-0.3-14.7-11-16-42.1c-1.3-30.7,9.1-71.3,9.7-73.5c-0.6,1.8-10.6,30.3-15.3,65c-3,22.5,0.9,35.4,4.1,42 c0.1,0.3,0.3,0.6,0.4,0.8c1.6,3,3.1,4.4,3.2,4.6l-4.4-1.6h-0.1c0,0,0,0-0.1-0.1c-0.5-0.2-2.3-1.3-4-4.7c-0.4-0.8-0.8-1.8-1.2-3 c-1.8-5.9-2.9-16.2-0.1-33.9c5.9-37.8,20.4-89.3,20.4-89.3s-22.3,30.4-31,64.7c0,0,0,0,0,0.1c-3.9,15.4-4,26.7-2.9,34.5 c1.3,9.2,4.2,13.4,4.4,13.8l0,0c-0.4-0.2-10.9-5.8-14.7-17.8c-1.4-4.4-1.9-9.7-0.7-15.9c0-0.3,0.1-0.5,0.2-0.8 C5.8,131.7,33,91,48.7,65.7C64.5,40.5,76.6,21.5,77,20.9c-14.6,8.7-35.7,17.4-36.4,17.7l3.9-3.1l0,0c0.3-0.1,5.4-2.2,18.6-9 c13.6-7,39-27.4,53.2-21c14.3,6.4,23.7,29.2,23.7,29.2L138.7,35.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.3,170.1c-2.2,24-26.5,35.6-27.3,35.9c1.2-0.8,2.4-1.7,3.6-2.8l0,0c0,0,0,0,0.1,0 c8.6-7.8,14.9-21.2,15.4-22.2c-5.5,9.8-14.4,20.9-22.2,25.4c-10.6,6-19.8,3.6-19.8,3.6c8.1-10.9,12.5-23.8,14.7-32 c-4.2,13-13.7,25.3-13.7,25.3c6.6-23.4,13.8-96.6,7.4-120.6c-3.9-14.4-13.2-27.3-20-35.4c1.1,0.9,18.8,16.3,26.1,49.9 c7.4,34.2-1.9,82.3-2.2,83.8c0.4-1.3,15.6-52.1,9.7-85.2c0.4,1.7,8.1,38.2,3.1,67c-5,29-10.3,38.3-10.4,38.6 c0.4-0.2,30.3-2.4,29.9-40.9c-0.3-29.4-8.5-50.6-9.6-70.4l0,0c0,0,2.2,11.3,4.9,26.4c2.3,12.6,5,27.8,7.1,41 c4.1,25.6-15,41.9-19.5,45.4c4.4-3.3,23.8-18.9,22-38.6c-1.9-20.8-5.1-32.8-5.5-34.2C209.9,142.7,213.6,156,212.3,170.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,189.5c0,0-15-12.9-12.7-35.6C5.8,131.2,26,103.3,26,103.3s-5.1,15.7-11.4,35.2S8.3,172.2,16.1,189.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.1,212.2c0,0-26.5-25.6-12.9-84.9c0,0-12,49.3,18.9,85.5L49.1,212.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168807884346464187380000015209708345033525387_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.6,
    y1: 125.09,
    x2: 169.6,
    y2: 175.89,
    gradientTransform: "matrix(1 0 0 -1 0 213.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168807884346464187380000015209708345033525387_)"
    },
    d: "M142.2,38.6c0,0,15.5,8.8,29.2,23.3 C185.2,76.4,197,88.8,197,88.8l-0.4-1.8c0,0-9.1-12.8-23.4-26.5c-14.3-13.8-28-21.1-28-21.1s17.2,5.3,31.6,16.9 c14.4,11.7,18,18.5,18,18.5l-1-5.9c0,0-10.6-13.2-24.2-20.1S142.8,38,142.8,38L142.2,38.6z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M29.8,47.3c0,0-1.9,4,0.8,6.9s14.8-0.9,18.2-1s9.3-2.4,9.3-2.4L45.7,70.7c0,0,1.1-2.5-1.5-5.3 c-2.6-2.8-14.2,1.6-20.1-1s-2.6-10-2.6-10L29.8,47.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M163.3,63.4c0,0,7.6,14.3,11.5,26.9c0,0,0.5-4.4,3.9-9c3.4-4.5,5.4-4.5,5.4-4.5l-11-13.1L163.3,63.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M174.8,62.1L180,59c0,0,5.1,4.2,8.2,7.6l-3.4,6.1C184.8,72.7,176.5,63.8,174.8,62.1z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 6500,
    height: 2889,
    xlinkHref: "../../../../Downloads/girl-face-construction-avatar-creation-with-different-head-parts-white/1Z_2011.w020.n001.838A.p30.838.jpg",
    transform: "matrix(0.1199 0 0 0.1199 256.5046 -76.5974)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair2);
export default __webpack_public_path__ + "static/media/Hair2.32c4d5cf8c71e239405ac6c3959679cd.svg";
export { ForwardRef as ReactComponent };